import { AbstractControl, AsyncValidator, AsyncValidatorFn, NG_ASYNC_VALIDATORS, ValidationErrors } from '@angular/forms';
import { Directive, forwardRef, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';

import { CheckEmailUseCase, IdInterface } from '../../../core';
import { emailExists } from './validator';

// noinspection JSAnnotator
@Directive({
    selector: '[emailExists][formControlName],[emailExists][formControl],[emailExists][ngModel]',
    providers: [
        {
            provide: NG_ASYNC_VALIDATORS,
            useExisting: forwardRef(() => EmailExistsValidatorDirective),
            multi: true,
        },
    ],
})
export class EmailExistsValidatorDirective implements AsyncValidator, OnInit {
    private validator: AsyncValidatorFn;

    @Input()
    emailExists = true;

    @Input()
    clientCode: IdInterface = null;

    constructor(private checkEmailUseCase: CheckEmailUseCase) {}

    ngOnInit() {
        this.validator = emailExists(this.emailExists, this.checkEmailUseCase, this.clientCode);
    }

    validate(c: AbstractControl): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> {
        return this.validator(c);
    }
}
